import React, { useState, useRef, useEffect } from 'react';
import { FaCode, FaMobileAlt, FaPaintBrush, FaRocket, FaChartLine, FaDatabase } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeService, setActiveService] = useState(null);
  const sectionRef = useRef(null);
  const { currentTheme } = useTheme();
  const { currentLanguage } = useLanguage();
  
  // Получение сервисов с учетом языка
  const getServices = () => {
    const servicesData = {
      ru: [
        {
          id: 1,
          icon: <FaCode className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "Веб-разработка",
          shortDesc: "Создание современных и функциональных веб-сайтов",
          description: "Разрабатываем современные веб-сайты и веб-приложения с использованием передовых технологий. Наши решения адаптивны, быстры и оптимизированы для поисковых систем. Мы создаем как простые лендинги, так и сложные корпоративные порталы и интернет-магазины.",
          benefits: ["Адаптивный дизайн", "SEO-оптимизация", "Высокая производительность", "Интеграция с CMS"],
          techStack: ["React", "Vue.js", "Next.js", "Node.js", "PHP", "WordPress"]
        },
        {
          id: 2,
          icon: <FaPaintBrush className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Веб-дизайн",
          shortDesc: "Создание современного дизайна сайтов и интерфейсов",
          description: "Разрабатываем привлекательный и функциональный дизайн веб-сайтов и интерфейсов. Наши дизайнеры создают уникальные визуальные решения, которые соответствуют вашему бренду и потребностям пользователей.",
          benefits: ["Уникальный стиль", "Улучшенный UX", "Адаптивный дизайн", "Современные тренды"],
          techStack: ["Figma", "Adobe XD", "Sketch", "HTML/CSS", "JavaScript"]
        },
        {
          id: 3,
          icon: <FaPaintBrush className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "UI/UX Дизайн",
          shortDesc: "Разработка интуитивно понятных и привлекательных интерфейсов",
          description: "Создаем современные, интуитивно понятные и эстетически привлекательные интерфейсы, которые повышают конверсию и улучшают взаимодействие пользователей с вашим продуктом. Мы разрабатываем уникальные макеты с учетом психологии пользователей и современных тенденций.",
          benefits: ["Прототипирование", "Пользовательское тестирование", "Анимации и микровзаимодействия", "Адаптивный дизайн"],
          techStack: ["Figma", "Adobe XD", "Sketch", "Photoshop", "Illustrator"]
        },
        {
          id: 4,
          icon: <FaRocket className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Digital-маркетинг",
          shortDesc: "Продвижение вашего бизнеса в цифровой среде",
          description: "Разрабатываем и внедряем комплексные стратегии цифрового маркетинга для продвижения вашего бизнеса. Мы используем различные каналы и инструменты для привлечения целевой аудитории и увеличения конверсии.",
          benefits: ["SEO-продвижение", "Контекстная реклама", "SMM-маркетинг", "Email-маркетинг"],
          techStack: ["Google Ads", "Яндекс.Директ", "Facebook Ads", "Instagram Ads", "Google Analytics"]
        },
        {
          id: 5,
          icon: <FaChartLine className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "Бизнес-аналитика",
          shortDesc: "Анализ данных и оптимизация бизнес-процессов",
          description: "Проводим анализ данных вашего бизнеса, выявляем проблемные места и предлагаем решения для оптимизации процессов. Наши специалисты помогут вам принимать решения на основе данных и улучшать показатели эффективности.",
          benefits: ["Анализ конкурентов", "Оптимизация процессов", "Разработка KPI", "Прогнозирование"],
          techStack: ["Power BI", "Tableau", "Google Data Studio", "Excel", "Python"]
        },
        {
          id: 6,
          icon: <FaDatabase className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Облачные решения",
          shortDesc: "Внедрение и оптимизация облачных сервисов",
          description: "Разрабатываем и внедряем облачные решения для вашего бизнеса. Мы поможем вам перенести ваши данные и приложения в облако, обеспечим безопасность и масштабируемость вашей IT-инфраструктуры.",
          benefits: ["Масштабируемость", "Безопасность", "Снижение затрат", "Высокая доступность"],
          techStack: ["AWS", "Google Cloud", "Microsoft Azure", "Docker", "Kubernetes"]
        },
      ],
      en: [
        {
          id: 1,
          icon: <FaCode className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "Web Development",
          shortDesc: "Creating modern and functional websites",
          description: "We develop modern websites and web applications using cutting-edge technologies. Our solutions are responsive, fast, and optimized for search engines. We create everything from simple landing pages to complex corporate portals and e-commerce sites.",
          benefits: ["Responsive design", "SEO optimization", "High performance", "CMS integration"],
          techStack: ["React", "Vue.js", "Next.js", "Node.js", "PHP", "WordPress"]
        },
        {
          id: 2,
          icon: <FaPaintBrush className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Web Design",
          shortDesc: "Creating modern website and interface designs",
          description: "We develop attractive and functional designs for websites and interfaces. Our designers create unique visual solutions that match your brand and user needs.",
          benefits: ["Unique style", "Improved UX", "Responsive design", "Modern trends"],
          techStack: ["Figma", "Adobe XD", "Sketch", "HTML/CSS", "JavaScript"]
        },
        {
          id: 3,
          icon: <FaPaintBrush className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "UI/UX Design",
          shortDesc: "Developing intuitive and attractive interfaces",
          description: "We create modern, intuitive, and aesthetically pleasing interfaces that increase conversion and improve user interaction with your product. We develop unique layouts based on user psychology and modern trends.",
          benefits: ["Prototyping", "User testing", "Animations and micro-interactions", "Responsive design"],
          techStack: ["Figma", "Adobe XD", "Sketch", "Photoshop", "Illustrator"]
        },
        {
          id: 4,
          icon: <FaRocket className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Digital Marketing",
          shortDesc: "Promoting your business in the digital environment",
          description: "We develop and implement comprehensive digital marketing strategies to promote your business. We use various channels and tools to attract your target audience and increase conversion.",
          benefits: ["SEO promotion", "PPC advertising", "Social media marketing", "Email marketing"],
          techStack: ["Google Ads", "Yandex.Direct", "Facebook Ads", "Instagram Ads", "Google Analytics"]
        },
        {
          id: 5,
          icon: <FaChartLine className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'}`} />,
          title: "Business Analytics",
          shortDesc: "Data analysis and business process optimization",
          description: "We analyze your business data, identify problem areas, and offer solutions to optimize processes. Our specialists will help you make data-driven decisions and improve performance indicators.",
          benefits: ["Competitor analysis", "Process optimization", "KPI development", "Forecasting"],
          techStack: ["Power BI", "Tableau", "Google Data Studio", "Excel", "Python"]
        },
        {
          id: 6,
          icon: <FaDatabase className={`text-4xl mb-4 ${currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'}`} />,
          title: "Cloud Solutions",
          shortDesc: "Implementation and optimization of cloud services",
          description: "We develop and implement cloud solutions for your business. We will help you migrate your data and applications to the cloud, ensure security and scalability of your IT infrastructure.",
          benefits: ["Scalability", "Security", "Cost reduction", "High availability"],
          techStack: ["AWS", "Google Cloud", "Microsoft Azure", "Docker", "Kubernetes"]
        },
      ]
    };
    
    return servicesData[currentLanguage] || servicesData.ru;
  };
  
  // Получение текстов с учетом языка
  const getText = () => {
    const texts = {
      ru: {
        sectionTitle: "Наши услуги",
        sectionDescription: "Мы предлагаем комплексные решения для вашего бизнеса в сфере цифровых технологий. Наша команда экспертов готова помочь вам реализовать проекты любой сложности.",
        benefits: "Преимущества:",
        technologies: "Технологии:"
      },
      en: {
        sectionTitle: "Our Services",
        sectionDescription: "We offer comprehensive solutions for your business in the field of digital technologies. Our team of experts is ready to help you implement projects of any complexity.",
        benefits: "Benefits:",
        technologies: "Technologies:"
      }
    };
    
    return texts[currentLanguage] || texts.ru;
  };
  
  const services = getServices();
  const texts = getText();

  // Отслеживание видимости секции
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Обработчик клика по сервису
  const handleServiceClick = (id) => {
    if (activeService === id) {
      setActiveService(null);
    } else {
      setActiveService(id);
    }
  };

  return (
    <section 
      id="services"
      ref={sectionRef}
      className={`py-20 relative overflow-hidden ${currentTheme === 'light' ? 'bg-gray-50' : 'bg-[#070707]'}`}
    >
      {/* Декоративные элементы */}
      <div className={`absolute top-0 left-0 w-full h-96 bg-gradient-to-b ${
        currentTheme === 'light' 
          ? 'from-light-primary/5 to-transparent' 
          : 'from-dark-primary/5 to-transparent'
      } opacity-30`}></div>
      <div className={`absolute bottom-0 right-0 w-full h-96 bg-gradient-to-t ${
        currentTheme === 'light' 
          ? 'from-light-secondary/5 to-transparent' 
          : 'from-dark-secondary/5 to-transparent'
      } opacity-30`}></div>
      <div className={`absolute top-1/2 left-1/4 w-72 h-72 rounded-full ${
        currentTheme === 'light' 
          ? 'bg-light-primary/5' 
          : 'bg-dark-primary/5'
      } blur-3xl`}></div>
      <div className={`absolute top-1/3 right-1/4 w-80 h-80 rounded-full ${
        currentTheme === 'light' 
          ? 'bg-light-secondary/5' 
          : 'bg-dark-secondary/5'
      } blur-3xl`}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div 
          className={`text-center mb-16 transition-all duration-700 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
          }`}
        >
          <h2 className={`text-4xl md:text-5xl font-bold mb-4 ${
            currentTheme === 'light'
              ? 'bg-clip-text text-transparent bg-gradient-to-r from-light-primary to-light-secondary'
              : 'bg-clip-text text-transparent bg-gradient-to-r from-dark-primary to-dark-secondary'
          }`}>
            {texts.sectionTitle}
          </h2>
          <div className={`w-20 h-1 bg-gradient-to-r ${
            currentTheme === 'light'
              ? 'from-light-primary to-light-secondary'
              : 'from-dark-primary to-dark-secondary'
          } mx-auto mb-6`}></div>
          <p className={`${
            currentTheme === 'light' ? 'text-gray-600' : 'text-gray-400'
          } max-w-2xl mx-auto`}>
            {texts.sectionDescription}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className={`relative rounded-2xl transition-all duration-500 transform cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onClick={() => handleServiceClick(service.id)}
            >
              {/* Карточка сервиса */}
              <div className={`
                h-full ${currentTheme === 'light' 
                  ? 'bg-white border border-gray-200'
                  : 'bg-gradient-to-br from-[#0A0A0A] to-[#111] border border-[#222]'
                } rounded-2xl p-6 transition-all duration-300
                ${activeService === service.id 
                  ? currentTheme === 'light' 
                    ? 'border-light-primary/60' 
                    : 'border-dark-primary/60'
                  : currentTheme === 'light'
                    ? 'hover:border-gray-300'
                    : 'hover:border-[#333]'
                }
              `}>
                {service.icon}
                <h3 className={`text-xl font-bold mb-2 ${
                  currentTheme === 'light' ? 'text-gray-800' : 'text-white'
                }`}>{service.title}</h3>
                
                {activeService !== service.id ? (
                  <p className={currentTheme === 'light' ? 'text-gray-600' : 'text-gray-400'}>{service.shortDesc}</p>
                ) : (
                  <div className="animate-fadeIn">
                    <p className={`mb-4 ${
                      currentTheme === 'light' ? 'text-gray-700' : 'text-gray-300'
                    }`}>{service.description}</p>
                    
                    <div className="mb-4">
                      <h4 className={`font-medium mb-2 ${
                        currentTheme === 'light' ? 'text-light-primary' : 'text-dark-primary'
                      }`}>{texts.benefits}</h4>
                      <ul className={`list-disc list-inside ${
                        currentTheme === 'light' ? 'text-gray-600' : 'text-gray-400'
                      }`}>
                        {service.benefits.map((benefit, idx) => (
                          <li key={idx} className="mb-1">{benefit}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <h4 className={`font-medium mb-2 ${
                      currentTheme === 'light' ? 'text-light-secondary' : 'text-dark-secondary'
                    }`}>{texts.technologies}</h4>
                    <div className="flex flex-wrap gap-2">
                      {service.techStack.map((tech, idx) => (
                        <span 
                          key={idx}
                          className={`px-3 py-1 text-sm rounded-full ${
                            currentTheme === 'light'
                              ? 'bg-gray-100 text-gray-700'
                              : 'bg-[#1A1A1A] text-gray-300'
                          }`}
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="absolute bottom-6 right-6">
                  <div className={`
                    w-6 h-6 rounded-full flex items-center justify-center
                    transition-transform duration-300
                    ${activeService === service.id ? 'rotate-45' : ''}
                  `}>
                    <span className={`block w-4 h-0.5 absolute ${
                      currentTheme === 'light'
                        ? 'bg-gradient-to-r from-light-primary to-light-secondary'
                        : 'bg-gradient-to-r from-dark-primary to-dark-secondary'
                    }`}></span>
                    <span className={`
                      block w-0.5 h-4 absolute
                      transition-opacity duration-300
                      ${activeService === service.id ? 'opacity-100' : 'opacity-100'}
                      ${currentTheme === 'light'
                        ? 'bg-gradient-to-r from-light-primary to-light-secondary'
                        : 'bg-gradient-to-r from-dark-primary to-dark-secondary'
                      }
                    `}></span>
                  </div>
                </div>
              </div>
              
              {/* Градиентная тень */}
              <div className={`
                absolute -inset-0.5 rounded-2xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-300
                ${activeService === service.id ? 'opacity-20' : ''}
                ${currentTheme === 'light'
                  ? 'bg-gradient-to-r from-light-primary to-light-secondary'
                  : 'bg-gradient-to-r from-dark-primary to-dark-secondary'
                }
              `}></div>
            </div>
          ))}
        </div>
        
        <div 
          className="mt-16 text-center"
          style={{ transform: isVisible ? 'translateY(0)' : 'translateY(30px)', opacity: isVisible ? 1 : 0, transition: 'all 0.7s ease 0.6s' }}
        >
          <a 
            href="/contact" 
            className={`inline-block px-8 py-4 rounded-full font-semibold transition-all duration-300 ${
              currentTheme === 'light'
                ? 'bg-gradient-to-r from-light-primary to-light-secondary text-white hover:shadow-lg hover:shadow-light-primary/20'
                : 'bg-gradient-to-r from-dark-primary to-dark-secondary text-white hover:shadow-lg hover:shadow-dark-primary/20'
            }`}
          >
            Обсудить ваш проект
          </a>
        </div>
      </div>
      
      {/* Добавляем стили для анимации */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.5s ease forwards;
        }
      `}</style>
    </section>
  );
};

export default Services; 